import { useContext } from "react";
import { format } from "date-fns";
import { endoso } from "services";
import { AuthContext } from "context/context";
import { EndosoContext } from "pages/endoso/context";
import { formatDate } from "pages/endoso/hooks";

const isSameDay = (startDate, endDate) => {
  if (!startDate || !endDate) return false;

  return (
    startDate.getFullYear() === endDate.getFullYear() &&
    startDate.getMonth() === endDate.getMonth() &&
    startDate.getDate() === endDate.getDate()
  );
};

const getMinutesFromTime = (time) => {
  if (!time) return null;
  return time.getHours() * 60 + time.getMinutes();
};

export const useRulesBy24 = () => {
  const { state } = useContext(AuthContext);
  const {
    formDta,
    createMessage,
    showButtons,
    setShowButtons,
    setContinueR24,
    textoSalidaAlumnos24: formData,
  } = useContext(EndosoContext);
  /* useSubmitData llama a este hook en CADA render de la pagina de endoso, sea
     cual sea el tipo, asi que se evalua aunque no exista poliza en contexto
     (p. ej. al recargar /endoso: AuthContext.state vive solo en memoria).
     Misma guarda que nuevoTexto-24/components/form/index.js:95. */
  const vigencia = { ini: state?.iniVigencia, fin: state?.finVigencia };

  const validate = () => {
    const {
      lugar,
      ubicacion,
      salida,
      horaSalida,
      regreso,
      horaRegreso,
      numeroAsegurados,
    } = formData;

    if (!lugar.trim()) {
      createMessage({ text: "El campo Lugar es requerido.", variant: "warning" });
      return false;
    }
    if (lugar.length > 40) {
      createMessage({ text: "El campo Lugar no puede superar 40 caracteres.", variant: "warning" });
      return false;
    }
    if (!/^[A-ZÑ0-9 ]*$/.test(lugar)) {
      createMessage({ text: "El campo Lugar solo permite mayúsculas, números y espacios.", variant: "warning" });
      return false;
    }
    if (!ubicacion.trim()) {
      createMessage({ text: "El campo Ubicación es requerido.", variant: "warning" });
      return false;
    }
    if (ubicacion.length > 40) {
      createMessage({ text: "El campo Ubicación no puede superar 40 caracteres.", variant: "warning" });
      return false;
    }
    if (!/^[A-ZÑ0-9 ]*$/.test(ubicacion)) {
      createMessage({ text: "El campo Ubicación solo permite mayúsculas, números y espacios.", variant: "warning" });
      return false;
    }
    if (!salida) {
      createMessage({ text: "La fecha de Salida es requerida.", variant: "warning" });
      return false;
    }
    if (!horaSalida) {
      createMessage({ text: "La hora de salida es requerida.", variant: "warning" });
      return false;
    }
    if (!regreso) {
      createMessage({ text: "La fecha de Regreso es requerida.", variant: "warning" });
      return false;
    }
    if (!horaRegreso) {
      createMessage({ text: "La hora de regreso es requerida.", variant: "warning" });
      return false;
    }

    const iniTs = new Date(formatDate(vigencia.ini)).getTime();
    const finTs = new Date(formatDate(vigencia.fin)).getTime();
    const todayTs = new Date().setHours(0, 0, 0, 0);
    const salidaTs = salida.getTime();
    const regresoTs = regreso.getTime();

    if (salidaTs < iniTs || salidaTs > finTs) {
      createMessage({ text: "la fecha seleccionada no se encuentra dentro de la vigencia de la póliza", variant: "warning" });
      return false;
    }
    if (salidaTs < todayTs) {
      createMessage({ text: "La fecha de Salida no puede ser anterior al día actual.", variant: "warning" });
      return false;
    }
    if (regresoTs < iniTs || regresoTs > finTs) {
      createMessage({ text: "la fecha seleccionada no se encuentra dentro de la vigencia de la póliza", variant: "warning" });
      return false;
    }
    if (regresoTs < salidaTs) {
      createMessage({ text: "La fecha de Regreso no puede ser anterior a la fecha de Salida.", variant: "warning" });
      return false;
    }

    if (
      isSameDay(salida, regreso) &&
      getMinutesFromTime(horaRegreso) < getMinutesFromTime(horaSalida)
    ) {
      createMessage({
        text: "La hora de regreso no puede ser anterior a la hora de salida.",
        variant: "warning",
      });
      return false;
    }

    if (numeroAsegurados === "" || numeroAsegurados == null) {
      createMessage({ text: "El campo Número de asegurados es requerido.", variant: "warning" });
      return false;
    }
    const numAse = parseInt(numeroAsegurados, 10);
    if (isNaN(numAse) || numAse <= 0) {
      createMessage({ text: "El Número de asegurados debe ser un número entero mayor a 0.", variant: "warning" });
      return false;
    }

    return true;
  };

  const handleGuardarBorrador = async () => {
    if (!validate()) return;
    try {
      const payload = {
        solicitud: formDta.noSolicitud,
        nivel: 1,
        llave: "001",
        valores: [
          { nmtabcam: 1, otvalact: formData.lugar },
          { nmtabcam: 2, otvalact: formData.ubicacion },
          { nmtabcam: 3, otvalact: format(formData.salida, "yyyy-MM-dd") },
          { nmtabcam: 4, otvalact: format(formData.regreso, "yyyy-MM-dd") },
          { nmtabcam: 5, otvalact: format(formData.horaSalida, "HH:mm") },
          { nmtabcam: 6, otvalact: format(formData.horaRegreso, "HH:mm") },
          {
            nmtabcam: 7,
            otvalact: String(parseInt(formData.numeroAsegurados, 10)),
          },
        ],
      };
      const response = await endoso.guardaTextos(payload);
      if (response?.data?.codigo === 1) {
        createMessage({ text: "Borrador guardado correctamente.", variant: "success" });
        setContinueR24(true);
        setShowButtons({ ...showButtons, infoTable: true });
      } else {
        createMessage({ text: response?.data?.mensaje || "Error al guardar el borrador.", variant: "warning" });
      }
    } catch {
      createMessage({ text: "Ocurrió un error al guardar el borrador.", variant: "warning" });
    }
  };

  return { handleGuardarBorrador };
};
